import { useEffect, useState } from 'react';
import useProducts from '../../constants/updateProducts';
import axios from 'axios';

function ProductList({ onClick, selectedProducts }) {
  const [products, setProducts] = useState([]);
  const useProduct = useProducts;

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          'https://one.lifebank.ng/api/v1/marketing/product'
        );

        setProducts(response.data.data);
      } catch (error) {
        console.error('API error:', error);
      }
    }
    fetchData();
  }, []);

  if (!products || !products.length) {
    return <div>Loading...</div>;
  }

  const getProductBorderStyle = (productId) => {
    switch (productId) {
      case 0:
        return {
          border: selectedProducts.includes(products[0].name)
            ? '4px solid #B70303'
            : '4px solid #cfd1d6',
        };
      case 1:
        return {
          border: selectedProducts.includes(products[1].name)
            ? '4px solid #0c348f'
            : '4px solid #cfd1d6',
        };
      case 2:
        return {
          border: selectedProducts.includes(products[2].name)
            ? '4px solid #00B87C'
            : '4px solid #cfd1d6',
        };
      case 3:
        return {
          border: selectedProducts.includes(products[3].name)
            ? '4px solid #f5a623'
            : '4px solid #cfd1d6',
        };
      default:
        return {
          border: '4px solid #cfd1d6',
        };
    }
  };

  return (
    <>
      {products.map((product, index) => (
        <div
          onClick={() => onClick(product.name)}
          style={getProductBorderStyle(index)}
          key={product.id}
          className="border-[4px] rounded-[10px] mt-8 max-h"
        >
          <div className="flex flex-col items-center justify-center gap-2 rounded-10 text-center lg:mt-1 mx-auto cursor-pointer p-2">
            <div className="font-bold text-sm lg:text-2xl p-1">
              {product.name}
            </div>
            <div>
              <img
                className="mx-auto"
                src={useProduct[index].img}
                alt={product.name}
              />
            </div>
            <div className="text-sm lg:text-[16px] font-normal p-1">
              {useProduct[index].description}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default ProductList;
